import axios from "axios";

export async function getReportGradeStatus(reportName) {
  return await axios.get(`/report-grade-status/by-name/${reportName}`);
}

